var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, Link, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { InfoFilledIcon } from '../../../assets/customIcons';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { RowModeIds } from '../../../builderPackage/components/editableDataGrid/editableDataGrid.entity';
import { MuiPopup, MuiStack } from '../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { showNotification } from '../../../redux/commonSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { UnitOfMeasurementList } from '../../jobCardDetails/services/apiCalls';
import { getLocationDetailsAPICall, getSerialNoDetails } from '../services/apiCalls';
import { SpareIssuesKeys, SpareIssueStatusEnum } from '../services/entity';
import IssueQuantityCell from './issueQuantityCell';
import LocationDetailCell from './locationDetailcell';
import { LocationMultiSelectPopUp } from './locationMultiSelectPopup';
import PartInfo from './partInfo';
import { SerialNumberSelect } from './serialNumberselect';
import StockAvailability from './stockAvailability';
var SpareIssuePartGrid = function (props) {
    var _crud$SpareIssuesKeys, _crud$SpareIssuesKeys2, _crud$SpareIssuesKeys3, _crud$SpareIssuesKeys6, _crud$SpareIssuesKeys9;
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'ProductIssueDetails' : _a;
    var currValue = value[name];
    var _b = useState(false), isSearchBoxVisible = _b[0], setIsSearchBoxVisible = _b[1];
    var _c = useState(''), searchValue = _c[0], setSearchValue = _c[1];
    var _d = useState(false), isSingleSelection = _d[0], setIsSingleSelection = _d[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _e = useState(), modalProps = _e[0], setModalProps = _e[1];
    var _f = useState(), locationModalProps = _f[0], setLocationModalProps = _f[1];
    var _g = useState(), issueQty = _g[0], setIssueQty = _g[1];
    var isMulitpleDoc = getLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC);
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var data = (_crud$SpareIssuesKeys = (_crud$SpareIssuesKeys2 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys2 === void 0 ? void 0 : _crud$SpareIssuesKeys2.data) !== null && _crud$SpareIssuesKeys !== void 0 ? _crud$SpareIssuesKeys : (_crud$SpareIssuesKeys3 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys3 === void 0 ? void 0 : _crud$SpareIssuesKeys3.data;
    var isDisable = isMulitpleDoc && mode !== 'add' || data == SpareIssueStatusEnum.Issued;
    useEffect(function () {
        var _crud$SpareIssuesKeys4, _crud$SpareIssuesKeys5;
        if ((_crud$SpareIssuesKeys4 = crud[SpareIssuesKeys.PartDetails]) !== null && _crud$SpareIssuesKeys4 !== void 0 && _crud$SpareIssuesKeys4.data && onChange)
            onChange(null, (_crud$SpareIssuesKeys5 = crud[SpareIssuesKeys.PartDetails]) === null || _crud$SpareIssuesKeys5 === void 0 ? void 0 : _crud$SpareIssuesKeys5.data);
    }, [(_crud$SpareIssuesKeys6 = crud[SpareIssuesKeys.PartDetails]) === null || _crud$SpareIssuesKeys6 === void 0 ? void 0 : _crud$SpareIssuesKeys6.data]);
    var dispatch = useAppDispatch();
    var NOT_ISSUED_PART = currValue === null || currValue === void 0 ? void 0 : currValue.filter(function (data) { return !((data === null || data === void 0 ? void 0 : data.SpareIssueStatusName) === SpareIssueStatusEnum.Issued && (data === null || data === void 0 ? void 0 : data.PendingQuantity) === 0); });
    useEffect(function () {
        var _crud$SpareIssuesKeys7, _crud$SpareIssuesKeys8;
        if ((_crud$SpareIssuesKeys7 = crud[SpareIssuesKeys.PartIssueDetails]) !== null && _crud$SpareIssuesKeys7 !== void 0 && _crud$SpareIssuesKeys7.data && onChange)
            onChange(null, (_crud$SpareIssuesKeys8 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys8 === void 0 || (_crud$SpareIssuesKeys8 = _crud$SpareIssuesKeys8.data) === null || _crud$SpareIssuesKeys8 === void 0 ? void 0 : _crud$SpareIssuesKeys8.ProductIssueDetails);
    }, [(_crud$SpareIssuesKeys9 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys9 === void 0 || (_crud$SpareIssuesKeys9 = _crud$SpareIssuesKeys9.data) === null || _crud$SpareIssuesKeys9 === void 0 ? void 0 : _crud$SpareIssuesKeys9.ProductIssueDetails]);
    var serialNoColumn = [{
            field: 'SerialNumber',
            headerName: 'Serial Number',
            editable: false,
            width: 300
        }];
    var columns = [{
            field: 'ProductName',
            headerName: 'Part name & code',
            editable: false,
            width: 220,
            align: 'left',
            headerAlign: 'left',
            renderCell: function (params) {
                var _params$row$ProductNa, _params$row, _params$row$Code, _params$row2;
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation)
                    return /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: 13,
                        fontWeight: 600
                    }, "Total");
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "100%"
                }, /*#__PURE__*/ React.createElement(MuiStack, {
                    flexDirection: "column"
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#1B1D21",
                        textTransform: "uppercase"
                    }
                }, (_params$row$ProductNa = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ProductName) !== null && _params$row$ProductNa !== void 0 ? _params$row$ProductNa : ""), /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontSize: 12,
                        fontWeight: 400,
                        color: "#6A7682"
                    }
                }, "#", (_params$row$Code = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.Code) !== null && _params$row$Code !== void 0 ? _params$row$Code : "")), params.hasFocus && /*#__PURE__*/ React.createElement(MuiStack, {
                    ml: 3
                }, /*#__PURE__*/ React.createElement(Link, {
                    sx: {
                        textDecoration: "none",
                        color: "inherit"
                    },
                    component: "button",
                    fontWeight: "medium",
                    fontSize: "sm",
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Dialog',
                                        Component: PartInfo,
                                        componentProps: {
                                            data: params === null || params === void 0 ? void 0 : params.row
                                        },
                                        containerProps: {
                                            fullWidth: true,
                                            maxWidth: 'xs'
                                        }
                                    }))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, /*#__PURE__*/ React.createElement(InfoFilledIcon, {
                    sx: {
                        height: "15.33px",
                        width: '15.33px'
                    }
                }))));
            }
        }, {
            field: 'RequestedQuantity',
            headerName: 'Requested Qty.',
            editable: false,
            width: 130,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            type: 'searchSelect',
            field: 'UnitOfMeasurementName',
            headerName: 'UOM',
            width: 132,
            headerAlign: 'left',
            getListData: UnitOfMeasurementList,
            apiKey: 'UnitOfMeasurementList',
            editable: true,
            getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.Name; },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                UnitOfMeasurementName: value === null || value === void 0 ? void 0 : value.Name,
                UnitOfMeasurementId: value === null || value === void 0 ? void 0 : value.id
            }); },
            valueGetter: function (val, row) {
                return {
                    Name: row === null || row === void 0 ? void 0 : row.UnitOfMeasurementName,
                    id: row === null || row === void 0 ? void 0 : row.UnitOfMeasurementId
                };
            }
        }, {
            field: 'AvailableQuantity',
            headerName: 'Available Qty.',
            editable: false,
            type: 'number',
            width: 130,
            align: 'left',
            headerAlign: 'left',
            renderCell: function (params) {
                var _params$row3, _params$row$Available, _params$row4, _params$row5;
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation)
                    return params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.AvailableQuantity;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, (_params$row$Available = params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.AvailableQuantity) !== null && _params$row$Available !== void 0 ? _params$row$Available : "", (params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.AvailableQuantity) && params.hasFocus && /*#__PURE__*/ React.createElement(MuiStack, {
                    ml: 4
                }, /*#__PURE__*/ React.createElement(Link, {
                    sx: {
                        textDecoration: "none",
                        color: "inherit"
                    },
                    component: "button",
                    fontWeight: "medium",
                    fontSize: "sm",
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Dialog',
                                        Component: StockAvailability,
                                        componentProps: {
                                            data: params === null || params === void 0 ? void 0 : params.row
                                        },
                                        containerProps: {
                                            fullWidth: true,
                                            maxWidth: 'xs'
                                        }
                                    }))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, /*#__PURE__*/ React.createElement(InfoFilledIcon, {
                    sx: {
                        height: "15.33px",
                        width: '15.33px'
                    }
                }))));
            }
        }, {
            field: 'LocationDetails',
            headerName: 'Location Details',
            editable: false,
            width: 200,
            align: 'left',
            headerAlign: 'left',
            renderCell: function (params) {
                var handleLocationDetailSubmit = function (selectedRows, rows, rowData) {
                    var _value$name;
                    var row = params === null || params === void 0 ? void 0 : params.row;
                    var data = rows === null || rows === void 0 ? void 0 : rows.filter(function (item, index) { return (item === null || item === void 0 ? void 0 : item.id) == selectedRows; });
                    var newRows = (_value$name = value[name]) === null || _value$name === void 0 ? void 0 : _value$name.map(function (r) {
                        var _params$row6;
                        return (params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            LocationDetails: data
                        }) : r;
                    });
                    if (onChange)
                        onChange(null, newRows);
                    setLocationModalProps(undefined);
                };
                var handleLocationDetailClick = function (e) {
                    var _params$row7, _params$row8;
                    var locationModalProps = {
                        selectedRows: params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 || (_params$row7 = _params$row7.LocationDetails[0]) === null || _params$row7 === void 0 ? void 0 : _params$row7.id,
                        onSubmit: handleLocationDetailSubmit,
                        apiRequest: {
                            TenantId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            ProductId: params === null || params === void 0 || (_params$row8 = params.row) === null || _params$row8 === void 0 ? void 0 : _params$row8.ChildId,
                            WarehouseId: value === null || value === void 0 ? void 0 : value.WarehouseId
                        },
                        apiCall: getLocationDetailsAPICall,
                        apiKey: SpareIssuesKeys === null || SpareIssuesKeys === void 0 ? void 0 : SpareIssuesKeys.LocationDetails,
                        columns: locationColumns,
                        title: t('Location Details'),
                        rowData: params.row
                    };
                    setLocationModalProps(locationModalProps);
                    setIsSearchBoxVisible(false);
                    setIsSingleSelection(true);
                };
                return /*#__PURE__*/ React.createElement(LocationDetailCell, _extends({}, params, {
                    modalProps: locationModalProps,
                    onClick: handleLocationDetailClick
                }));
            }
        }, {
            field: 'IssueQuantity',
            headerName: 'Issue Qty',
            editable: mode === "add",
            type: 'number',
            width: 127,
            align: 'left',
            headerAlign: 'left',
            renderCell: function (params) {
                var _params$row9, _params$row10;
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation)
                    return params === null || params === void 0 || (_params$row9 = params.row) === null || _params$row9 === void 0 ? void 0 : _params$row9.IssueQuantity;
                var disableStatus = (params === null || params === void 0 || (_params$row10 = params.row) === null || _params$row10 === void 0 ? void 0 : _params$row10.StatusName) == SpareIssueStatusEnum.Issued || isDisable;
                var handleSerialNumberSubmit = function (selectedRows, rows) {
                    var _params$row11;
                    var serialNoArray = [];
                    if ((selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length) == ((_params$row11 = params.row) === null || _params$row11 === void 0 ? void 0 : _params$row11.IssueQuantity)) {
                        var _value$name2;
                        rows.map(function (item) { return selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.filter(function (elem) {
                            if (elem === (item === null || item === void 0 ? void 0 : item.id))
                                serialNoArray === null || serialNoArray === void 0 || serialNoArray.push(item === null || item === void 0 ? void 0 : item.SerialNumber);
                        }); });
                        var newRows = (_value$name2 = value[name]) === null || _value$name2 === void 0 ? void 0 : _value$name2.map(function (r) { return (params === null || params === void 0 ? void 0 : params.id) === r.id ? _objectSpread(_objectSpread({}, r), {}, {
                            SerialNumber: selectedRows,
                            SerialNoName: serialNoArray,
                            selectedSerialNo: selectedRows
                        }) : r; });
                        if (onChange)
                            onChange(null, newRows);
                        setModalProps(undefined);
                    }
                    else {
                        var _params$row12;
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Please select ".concat(params === null || params === void 0 || (_params$row12 = params.row) === null || _params$row12 === void 0 ? void 0 : _params$row12.IssueQuantity, " Serial No."),
                            type: "error"
                        }));
                    }
                };
                var handleSerialNumberClick = function (e) {
                    var _params$row13, _params$row14, _params$row15, _params$row16;
                    var modalProps = {
                        selectedRows: params === null || params === void 0 || (_params$row13 = params.row) === null || _params$row13 === void 0 ? void 0 : _params$row13.SerialNumber,
                        onSubmit: handleSerialNumberSubmit,
                        apiRequest: {
                            "TenantId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            "ProductId": params === null || params === void 0 || (_params$row14 = params.row) === null || _params$row14 === void 0 ? void 0 : _params$row14.ChildId,
                            "LocationId": params === null || params === void 0 || (_params$row15 = params.row) === null || _params$row15 === void 0 ? void 0 : _params$row15.LocationDetails[0].LocationId,
                            "Quantity": params === null || params === void 0 || (_params$row16 = params.row) === null || _params$row16 === void 0 ? void 0 : _params$row16.IssueQuantity,
                            "SerialNumber": [],
                            "ParentTenantId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId
                        },
                        apiCall: getSerialNoDetails,
                        apiKey: SpareIssuesKeys.GetSerialNumber,
                        columns: serialNoColumn,
                        title: '',
                        rowData: params.row
                    };
                    setModalProps(modalProps);
                    setIsSearchBoxVisible(disableStatus ? false : true);
                    setIsSingleSelection(false);
                };
                return /*#__PURE__*/ React.createElement(IssueQuantityCell, _extends({}, params, {
                    onButtonClick: handleSerialNumberClick,
                    isSerialized: true
                }));
            },
            valueSetter: function (value, row) {
                var newValue = value > 0 ? value : 0;
                setIssueQty(value);
                return _objectSpread(_objectSpread({}, row), {}, {
                    Total: (row === null || row === void 0 ? void 0 : row.IssueQuantity) * (row === null || row === void 0 ? void 0 : row.Cost) ? row === null || row === void 0 ? void 0 : row.Cost : 0,
                    IssueQuantity: newValue,
                    PendingQuantity: (row === null || row === void 0 ? void 0 : row.RequestedQuantity) - (newValue + (row === null || row === void 0 ? void 0 : row.IssuedQuantity))
                });
            }
        }, {
            field: 'IssuedQuantity',
            headerName: 'Issued Qty',
            editable: false,
            width: 127,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'PendingQuantity',
            headerName: 'Pending Qty',
            editable: false,
            type: 'number',
            width: 131,
            align: 'left',
            headerAlign: 'left'
        },
        // {
        //     field: 'SerialNumber',
        //     headerName: 'Serial Number',
        //     editable: false,
        //     width: 182,
        //     type: 'number',
        //     align: 'left',
        //     headerAlign: 'left',
        // },
        {
            field: 'Cost',
            headerName: 'Cost (₹) ',
            editable: false,
            width: 118,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'Total',
            headerName: 'Total cost (₹)',
            editable: false,
            type: 'number',
            width: 132,
            align: 'left',
            headerAlign: 'left'
        }];
    var locationColumns = [{
            field: 'LocationName',
            headerName: 'Location Name',
            editable: false
        }, {
            field: 'QuantityAvailable',
            headerName: 'Available Qty.',
            editable: false
        }, {
            field: 'IssueQuantity',
            headerName: 'Issue Qty',
            editable: true,
            renderCell: function (params) {
                var _params$row18;
                if ((params === null || params === void 0 ? void 0 : params.value) > 0) {
                    var _value$name3;
                    setIssueQty(params === null || params === void 0 ? void 0 : params.value);
                    (_value$name3 = value[name]) === null || _value$name3 === void 0 || _value$name3.map(function (r) {
                        var _params$row17;
                        return (params === null || params === void 0 || (_params$row17 = params.row) === null || _params$row17 === void 0 ? void 0 : _params$row17.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            IssueQuantity: issueQty
                        }) : r;
                    });
                }
                return /*#__PURE__*/ React.createElement(Typography, null, params === null || params === void 0 || (_params$row18 = params.row) === null || _params$row18 === void 0 ? void 0 : _params$row18.IssueQuantity);
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: mode === "add" ? NOT_ISSUED_PART : currValue || [],
        onChange: onChange,
        disableAddRow: true,
        disableDeleteRow: mode === "edit" ? true : false,
        dataGridHeader: 'Part Details',
        dataGridProps: {
            initialState: {
                pinnedColumns: {
                    left: ['__check__', 'ProductName'],
                    right: ['Total']
                },
                aggregation: {
                    model: {
                        Amount: 'sum',
                        TradeDiscountAmount: 'sum',
                        PendingQuantity: 'sum',
                        AvailableQuantity: 'sum',
                        IssueQuantity: 'sum',
                        IssuedQuantity: 'sum',
                        RequestedQuantity: 'sum',
                        Cost: 'sum',
                        Total: 'sum'
                    }
                }
            },
            disableColumnSorting: true,
            disableColumnMenu: false,
            checkboxSelection: mode === "edit" ? false : true,
            onCellKeyDown: function (params, e) {
                if (e.key === 'Enter')
                    e.preventDefault();
            },
            isCellEditable: function (params) {
                var _params$row19;
                return mode === "add" ? (params === null || params === void 0 || (_params$row19 = params.row) === null || _params$row19 === void 0 ? void 0 : _params$row19.StatusName) !== SpareIssueStatusEnum.Issued : false;
            },
            sx: {
                borderRadius: '12px !important'
            }
        },
        validationModel: {
            IssueQuantity: function (value, row) {
                var _row$RequestedQuantit, _row$AvailableQuantit;
                console.log("what s issue value", value);
                var updatedReqQty = (row === null || row === void 0 ? void 0 : row.RequestedQuantity) - (row === null || row === void 0 ? void 0 : row.IssuedQuantity);
                return value === 0 ? "Issue quantity must not be 0" : value > ((_row$RequestedQuantit = row === null || row === void 0 ? void 0 : row.RequestedQuantity) !== null && _row$RequestedQuantit !== void 0 ? _row$RequestedQuantit : 0) ? "Issue quantity cannot be more than requested quantity." : value > ((_row$AvailableQuantit = row === null || row === void 0 ? void 0 : row.AvailableQuantity) !== null && _row$AvailableQuantit !== void 0 ? _row$AvailableQuantit : 0) ? "Available stock is lesser than issue quantity." : value > updatedReqQty ? "Issue quantity cannot be more than pending quantity." : "";
            }
        },
        error: error === null || error === void 0 ? void 0 : error['ProductIssueDetails']
    })), /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "part-serialno-popup",
        variant: "h3",
        openPopup: Boolean(modalProps),
        onClose: function () {
            setModalProps(undefined);
        },
        closeIcon: isSearchBoxVisible !== null && isSearchBoxVisible !== void 0 ? isSearchBoxVisible : false,
        title: mode === "add" ? "Add Serial Number" : "Serial Number",
        width: '586px',
        searchBox: false,
        backdropEnable: false
    }, modalProps && /*#__PURE__*/ React.createElement(SerialNumberSelect, _extends({}, modalProps, {
        onClose: function () { return setModalProps(undefined); },
        singleSelection: isSingleSelection,
        issueQuantity: issueQty,
        searchValue: searchValue
    }))), locationModalProps && /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "part-location-popup",
        variant: "h1",
        openPopup: Boolean(locationModalProps),
        onClose: function () {
            setLocationModalProps(undefined);
        },
        closeIcon: isSearchBoxVisible !== null && isSearchBoxVisible !== void 0 ? isSearchBoxVisible : false,
        title: locationModalProps === null || locationModalProps === void 0 ? void 0 : locationModalProps.title,
        searchBox: isSearchBoxVisible !== null && isSearchBoxVisible !== void 0 ? isSearchBoxVisible : false,
        onSearchChange: function (value) { return setSearchValue(value); },
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: false,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? '500px' : 'calc(90vw)',
            paddingTop: 0,
            paddingX: "16px"
        }
    }, locationModalProps && /*#__PURE__*/ React.createElement(LocationMultiSelectPopUp, _extends({}, locationModalProps, {
        onClose: function () { return setLocationModalProps(undefined); },
        singleSelection: isSingleSelection,
        issueQuantity: issueQty,
        searchValue: searchValue
    }))));
};
export default SpareIssuePartGrid;
